import React, { useState } from "react";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Services } from "./Services";
import { Pricing } from "./Pricing";
import { ValueAdded } from "./ValueAdded";
import { Prestation } from "./Prestation";
import { Testimonials } from "./Testimonials";
import { Footer } from "./Footer";
import { ContactModal } from "./ContactModal";

function Home() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header onContactClick={openContactModal} onSectionClick={scrollToSection} />
      <div className="bg-[#0A0A0A]">
        <Hero onContactClick={openContactModal} />
      </div>
      <div id="services" className="bg-[#1A1A1A]">
        <Services />
      </div>
      <div id="tarifs" className="bg-[#0A0A0A]">
        <Pricing onContactClick={openContactModal} />
      </div>
      <div id="valeur-ajoutee" className="bg-[#1A1A1A]">
        <ValueAdded />
      </div>
      <div id="prestations" className="bg-[#0A0A0A]">
        <Prestation />
      </div>
      <div id="temoignages" className="bg-[#1A1A1A]">
        <Testimonials />
      </div>
      <div className="bg-[#1A1A1A]">
        <Footer />
      </div>
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
}

export default Home;
